import { State, Action } from './typings'
import { resetDefault, selectItems, sortItems, toggleItem } from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'toggle':
      return toggleItem(state, action.payload)

    case 'select':
      return selectItems(state, action.payload)

    case 'sort':
      return sortItems(state, action.payload)

    case 'resetDefault':
      return resetDefault(state)

    default:
      return state
  }
}
